module.exports = __webpack_public_path__ + "static/media/accessory26.7c32da00.webp";